import React from "react";
import { API_DIRECTORY_THEME } from "../../../../../../utils/constants";

export function BundleCardApiList({ apis, belongsTo }) {
  return (
    <div className="api-dir-pkg_bundle_api_list_wrapper">
      {belongsTo === API_DIRECTORY_THEME.DEALER_API_DIRECTORY && (
        <div>
          <div className="api-dir-pkg_bundle_apis_scroll">
            {(apis || []).slice(0, 3).map((api, idx) => {
              const isLast = idx === 2 && apis?.length > 3;
              return (
                <div className="api-dir-pkg_dealer_dealer_api-font" key={idx}>
                  <p data-testid={`api-name-test-id-${idx}`}>
                    {api?.name}
                    {isLast && ` (+${apis?.length - 3})`}
                    <br />
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {belongsTo === API_DIRECTORY_THEME.ISV_API_DIRECTORY && (
        <div
          className={`api-dir-pkg_bundle_card_middle_div ${
            (apis || []).length > 3 ? "background" : ""
          }`}
        >
          <div
            className={
              (apis || []).length > 3
                ? "api-dir-pkg_bundle_apis_scroll_gray"
                : "api-dir-pkg_bundle_apis_scroll"
            }
          >
            {(apis || []).map(function(api, idx) {
              return (
                <div className="api-dir-pkg_api-font" key={idx}>
                  <p>
                    {api?.name}
                    <br />
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
